import { createSlice } from '@reduxjs/toolkit';
import { _setEmployees } from './employeesAction';

export const employeesSlice = createSlice({
  name: 'delta/employees',
  initialState: null,
  reducers: {
    setEmployees: _setEmployees,
    resetEmployees: () => null,
  },
});

export const { setEmployees, resetEmployees } = employeesSlice.actions;

export default employeesSlice.reducer;
